var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19154",
    "data-name": "Group 19154",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20.007,
    viewBox: "0 0 20 20.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #25D366;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18543",
    "data-name": "Rectangle 18543",
    className: "cls-1",
    width: 20,
    height: 20.007
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19153",
    "data-name": "Group 19153",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7588",
    "data-name": "Path 7588",
    className: "cls-1",
    d: "M.463,20C.509,19.65.551,19.323.6,19c.1-.735.2-1.469.3-2.2.087-.652.174-1.3.255-1.956a.385.385,0,0,0-.038-.212,10.082,10.082,0,0,1-1.062-5.6A9.692,9.692,0,0,1,1.359,4.965,9.874,9.874,0,0,1,7.806.246,9.3,9.3,0,0,1,10.491.017a9.994,9.994,0,0,1,9.333,8.136,9.324,9.324,0,0,1,.17,2.117,9.873,9.873,0,0,1-2.774,6.657,9.789,9.789,0,0,1-5.351,2.905,10.065,10.065,0,0,1-2.83.131,9.568,9.568,0,0,1-3.191-.838.265.265,0,0,0-.147-.017q-1.462.246-2.924.5L.463,20M5.077,7.775a5.031,5.031,0,0,0,.141.7,9.658,9.658,0,0,0,3.193,4.689,9.335,9.335,0,0,0,3.939,1.859,1.55,1.55,0,0,0,1.534-.467c.236-.251.455-.52.671-.79.375-.467.349-.734-.124-1.109-.347-.275-.709-.532-1.07-.789a.584.584,0,0,0-.829.009c-.2.152-.378.332-.563.5-.168.155-.328.319-.5.473a.287.287,0,0,1-.373.027c-.143-.088-.292-.167-.436-.254A7.788,7.788,0,0,1,7.774,9.761a7.19,7.19,0,0,1-.352-.806.231.231,0,0,1,.106-.321,1.112,1.112,0,0,0,.25-.224,1.136,1.136,0,0,0,.29-1.259c-.144-.36-.273-.725-.421-1.083a3.164,3.164,0,0,0-.292-.585A.532.532,0,0,0,6.66,5.3a2.166,2.166,0,0,0-.388.221A2.63,2.63,0,0,0,5.077,7.775",
    transform: "translate(0 -0.001)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/Icon_Whatsapp.9f60d55c6b93c8d4bb818a2f162cedd3.svg";
export { ForwardRef as ReactComponent };